import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8eae7eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label text-muted"
}, " รหัสผ่าน: ", -1))
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_18 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "active",
  class: "form-label text-muted"
}, " สถานะการใช้งาน: ", -1))
const _hoisted_20 = { class: "form-check form-switch" }
const _hoisted_21 = {
  class: "form-check-label",
  for: "active"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "userForm",
    backdrop: "static",
    overflow: true,
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: "userName",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.userName}])
          }, " ชื่อผู้ใช้งาน: ", 2),
          (_ctx.submited && _ctx.errors.userName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " * กรุณาป้อนชื่อผู้ใช้งาน "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.userName) = $event)),
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.userName}]),
            placeholder: "กรุณาป้อนชื่อผู้ใช้งาน...",
            "aria-label": "userName",
            autocomplete: "off",
            disabled: _ctx.isEditMode,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, null, 42, _hoisted_5), [
            [
              _vModelText,
              _ctx.formData.userName,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: true,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
                class: "form-control",
                "aria-label": "password"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.formData.password,
                  void 0,
                  { trim: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", {
                for: "firstName",
                class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.firstName}])
              }, " ชื่อ: ", 2),
              (_ctx.submited && _ctx.errors.firstName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " * กรุณาป้อนชื่อ "))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.firstName) = $event)),
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.firstName}]),
                placeholder: "กรุณาป้อนชื่อ...",
                "aria-label": "firstName",
                autocomplete: "off",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.formData.firstName,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", {
                for: "lastName",
                class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.lastName}])
              }, " นามสกุล: ", 2),
              (_ctx.submited && _ctx.errors.lastName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, " * กรุณาป้อนนามสกุล "))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.lastName) = $event)),
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.lastName}]),
                placeholder: "กรุณาป้อนนามสกุล...",
                "aria-label": "lastName",
                autocomplete: "off",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.formData.lastName,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", {
            for: "email",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.email}])
          }, " อีเมล: ", 2),
          (_ctx.submited && _ctx.errors.email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " * กรุณาป้อนอีเมล "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.email) = $event)),
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.email}]),
            placeholder: "กรุณาป้อนอีเมล...",
            "aria-label": "email",
            autocomplete: "off",
            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.formData.email,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", {
            for: "provinces",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.roles}])
          }, " สิทธิ์การใช้งาน: ", 2),
          (_ctx.submited && _ctx.errors.roles)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " * กรุณาเลือกสิทธิ์การใช้งาน "))
            : _createCommentVNode("", true),
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.formData.roles,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.roles) = $event)),
            mode: "tags",
            placeholder: "กรุณาเลือกสิทธิ์การใช้งาน",
            searchable: true,
            options: _ctx.roleOptions
          }, null, 8, ["modelValue", "options"])
        ]),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "active",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.isActive) = $event)),
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearSubmit && _ctx.clearSubmit(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.formData.isActive]
                ]),
                _createElementVNode("label", _hoisted_21, _toDisplayString((_ctx.formData.isActive) ? 'ปกติ' : 'ระงับการใช้งานระบบ'), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_23,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_22),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_25,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_24)
    ]),
    _: 1
  }, 8, ["onHide"]))
}